import { Box, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { zoneI } from "../../../../../../../hooks/UbicationFilterContext";
import { LocationDropdownProps } from "../LocationDropdown";

const DefaultLocationDropdown: React.FC<LocationDropdownProps> = ({
  ubicationFilterList,
  onSelect,
}) => {
  const [zones, setZones] = useState<zoneI[]>([]);

  const renderLists = (filterList: zoneI[]) => {
    let list: Array<zoneI> = filterList.reduce((acum, filterZone) => {
      acum = [...acum, filterZone];
      if (filterZone.hotelDataList?.length) {
        filterZone.hotelDataList.map((hotel) => {
          return (acum = [...acum, hotel]);
        });
      }
      if (filterZone.zoneDataList) {
        acum = [...acum, ...renderLists(filterZone.zoneDataList)];
      }
      return acum;
    }, [] as Array<zoneI>);
    return list;
  };

  useEffect(() => {
    setZones(renderLists(ubicationFilterList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ubicationFilterList]);

  return (
    <Box>
      {zones.map((zone) => {
        const nestingPadding = zone.neesting + 1;
        const leftPadding = nestingPadding > 0 ? nestingPadding : 1;
        return (
          <MenuItem
            key={zone.id}
            onClick={() => onSelect(zone)}
            sx={{
              paddingLeft: `${leftPadding}em`,
            }}
          >
            {zone.name}
          </MenuItem>
        );
      })}
    </Box>
  );
};

export default DefaultLocationDropdown;
